import { PropsWithChildren, ReactElement, ReactNode } from "react";

export type ConditionalWrapperProps = {
	condition: boolean;
	wrapper(children: ReactNode): ReactElement;
};

export const ConditionalWrapper = (props: PropsWithChildren<ConditionalWrapperProps>): ReactElement => {
	const {
		condition,
		wrapper,
		children
	} = props;

	return (
		<>
			{ condition
				? wrapper(children)
				: children
			}
		</>
	);
};
ConditionalWrapper.displayName = "ConditionalWrapper";
